module.exports = __webpack_public_path__ + "home-block-1-ico-3-EIpl22t.png";